"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.hasClass = exports.Shortcut = void 0;
var React = __importStar(require("react"));
var video_context_1 = require("../context/video-context");
var react_1 = require("@xstate/react");
var selectors_1 = require("../selectors");
var screenfull_1 = __importDefault(require("screenfull"));
var useShortcutState = function () {
    var videoService = (0, video_context_1.useVideo)();
    var hasStarted = (0, react_1.useSelector)(videoService, selectors_1.selectHasStarted);
    var isActive = (0, react_1.useSelector)(videoService, selectors_1.selectIsActive);
    var paused = (0, react_1.useSelector)(videoService, selectors_1.selectIsPaused);
    var duration = (0, react_1.useSelector)(videoService, selectors_1.selectDuration);
    var currentTime = (0, react_1.useSelector)(videoService, selectors_1.selectCurrentTime);
    var playbackRate = (0, react_1.useSelector)(videoService, selectors_1.selectPlaybackRate);
    var rootElem = (0, react_1.useSelector)(videoService, selectors_1.selectRootElem);
    var readyState = (0, react_1.useSelector)(videoService, selectors_1.selectReadyState);
    var video = (0, react_1.useSelector)(videoService, selectors_1.selectVideo);
    var volume = (0, react_1.useSelector)(videoService, selectors_1.selectVolume);
    var cueFormElem = (0, react_1.useSelector)(videoService, selectors_1.selectCueFormElem);
    var shortcutsEnabled = (0, react_1.useSelector)(videoService, selectors_1.selectShortcutsEnabled);
    var isFullscreen = (0, react_1.useSelector)(videoService, selectors_1.selectIsFullscreen);
    return {
        videoService: videoService,
        hasStarted: hasStarted,
        isActive: isActive,
        paused: paused,
        duration: duration,
        currentTime: currentTime,
        playbackRate: playbackRate,
        rootElem: rootElem,
        readyState: readyState,
        volume: volume,
        cueFormElem: cueFormElem,
        shortcutsEnabled: shortcutsEnabled,
        video: video,
        isFullscreen: isFullscreen,
    };
};
/**
 * defines keyboard shortcuts for the video player
 * @param clickable
 * @param dblclickable
 * @param props
 * @param canAddNotes
 * @param enableGlobalShortcuts
 * @constructor
 */
var Shortcut = function (_a) {
    var _b = _a.clickable, clickable = _b === void 0 ? true : _b, _c = _a.dblclickable, dblclickable = _c === void 0 ? true : _c, _d = _a.canAddNotes, canAddNotes = _d === void 0 ? false : _d, enableGlobalShortcuts = _a.enableGlobalShortcuts, props = __rest(_a, ["clickable", "dblclickable", "canAddNotes", "enableGlobalShortcuts"]);
    var _e = useShortcutState(), videoService = _e.videoService, hasStarted = _e.hasStarted, isActive = _e.isActive, paused = _e.paused, duration = _e.duration, currentTime = _e.currentTime, playbackRate = _e.playbackRate, rootElem = _e.rootElem, readyState = _e.readyState, volume = _e.volume, cueFormElem = _e.cueFormElem, shortcutsEnabled = _e.shortcutsEnabled, isFullscreen = _e.isFullscreen;
    var shortCutsRef = React.useRef([]);
    React.useEffect(function () {
        if (screenfull_1.default.isEnabled) {
            screenfull_1.default.onchange(function () {
                if (!screenfull_1.default.isFullscreen) {
                    videoService.send({
                        type: 'EXIT_FULLSCREEN',
                        element: rootElem,
                    });
                }
            });
            return function () {
                screenfull_1.default.off('change', function () { });
            };
        }
    }, []);
    var togglePlay = React.useCallback(function () {
        if (paused) {
            videoService.send({ type: 'PLAY', source: 'shortcut' });
        }
        else {
            videoService.send({ type: 'PAUSE', source: 'shortcut' });
        }
    }, [paused, videoService]);
    var mergeShortcuts = React.useCallback(function () {
        var standardShortcuts = [
            {
                keyCode: 32,
                handle: function () { return togglePlay(); },
            },
            {
                keyCode: 75,
                handle: function () { return togglePlay(); },
            },
            {
                keyCode: 70,
                ctrl: false,
                handle: function () {
                    if (!isFullscreen) {
                        videoService.send({
                            type: 'TOGGLE_FULLSCREEN',
                            element: rootElem,
                        });
                    }
                    else {
                        videoService.send({
                            type: 'EXIT_FULLSCREEN',
                            element: rootElem,
                        });
                    }
                },
            },
            {
                keyCode: 67,
                ctrl: false,
                handle: function () {
                    var _a;
                    if (canAddNotes) {
                        // focus the cue note input
                        (_a = cueFormElem === null || cueFormElem === void 0 ? void 0 : cueFormElem.input) === null || _a === void 0 ? void 0 : _a.focus();
                        // start note taking session
                        videoService.send({ type: 'TAKE_NOTE', source: 'shortcut' });
                        // pause video playback
                        videoService.send({ type: 'CHANGE' });
                    }
                },
            },
            {
                keyCode: 37,
                handle: function () {
                    if (!hasStarted) {
                        return;
                    }
                    var seekingTime = currentTime - 5;
                    videoService.send({
                        type: 'SEEKING',
                        seekingTime: seekingTime > 0 ? seekingTime : 0,
                        source: 'shortcut',
                    });
                    videoService.send({ type: 'END_SEEKING' });
                },
            },
            {
                keyCode: 74,
                ctrl: false,
                handle: function () {
                    if (!hasStarted) {
                        return;
                    }
                    var seekingTime = currentTime - 10;
                    videoService.send({
                        type: 'SEEKING',
                        seekingTime: seekingTime > 0 ? seekingTime : 0,
                        source: 'shortcut',
                    });
                    videoService.send({ type: 'END_SEEKING' });
                },
            },
            {
                keyCode: 39,
                handle: function () {
                    if (!hasStarted) {
                        return;
                    }
                    var seekingTime = currentTime + 5;
                    videoService.send({
                        type: 'SEEKING',
                        seekingTime: seekingTime < duration ? seekingTime : duration,
                        source: 'shortcut',
                    });
                    videoService.send({ type: 'END_SEEKING' });
                },
            },
            {
                keyCode: 76,
                handle: function () {
                    if (!hasStarted) {
                        return;
                    }
                    var seekingTime = currentTime + 10;
                    videoService.send({
                        type: 'SEEKING',
                        seekingTime: seekingTime < duration ? seekingTime : duration,
                        source: 'shortcut',
                    });
                    videoService.send({ type: 'END_SEEKING' });
                },
            },
            {
                keyCode: 36,
                handle: function () {
                    if (!hasStarted) {
                        return;
                    }
                    videoService.send({
                        type: 'SEEKING',
                        seekingTime: 0,
                        source: 'shortcut',
                    });
                },
            },
            {
                keyCode: 35,
                handle: function () {
                    if (!hasStarted) {
                        return;
                    }
                    // Go to end of video
                    videoService.send({
                        type: 'SEEKING',
                        seekingTime: duration,
                        source: 'shortcut',
                    });
                },
            },
            {
                keyCode: 38,
                handle: function () {
                    // Increase volume 5%
                    var v = volume + 0.05;
                    if (v > 1) {
                        v = 1;
                    }
                    videoService.send({
                        type: 'VOLUME_CHANGE',
                        volume: v < 1.0 ? v : 1.0,
                        source: 'shortcut',
                    });
                },
            },
            {
                keyCode: 40,
                handle: function () {
                    // Decrease volume 5%
                    var v = volume - 0.05;
                    if (v < 0) {
                        v = 0;
                    }
                    //TODO difference between volume down and volume off actions
                    videoService.send({
                        type: 'VOLUME_CHANGE',
                        volume: v > 0 ? v : 0,
                        source: 'shortcut',
                    });
                },
            },
            {
                keyCode: 190,
                shift: true,
                handle: function () {
                    // Increase speed
                    var newPlaybackRate = playbackRate;
                    if (playbackRate >= 1.5) {
                        newPlaybackRate = 2;
                    }
                    else if (playbackRate >= 1.25) {
                        newPlaybackRate = 1.5;
                    }
                    else if (playbackRate >= 1.0) {
                        newPlaybackRate = 1.25;
                    }
                    else if (playbackRate >= 0.5) {
                        newPlaybackRate = 1.0;
                    }
                    else if (playbackRate >= 0.25) {
                        newPlaybackRate = 0.5;
                    }
                    else if (playbackRate >= 0) {
                        newPlaybackRate = 0.25;
                    }
                    videoService.send({
                        type: 'PLAYBACKRATE_CHANGE',
                        playbackRate: newPlaybackRate,
                        source: 'shortcut',
                    });
                },
            },
            {
                keyCode: 188,
                shift: true,
                handle: function () {
                    // Decrease speed
                    var newPlaybackRate = playbackRate;
                    if (playbackRate <= 0.5) {
                        newPlaybackRate = 0.25;
                    }
                    else if (playbackRate <= 1.0) {
                        newPlaybackRate = 0.5;
                    }
                    else if (playbackRate <= 1.25) {
                        newPlaybackRate = 1.0;
                    }
                    else if (playbackRate <= 1.5) {
                        newPlaybackRate = 1.25;
                    }
                    else if (playbackRate <= 2) {
                        newPlaybackRate = 1.5;
                    }
                    videoService.send({
                        type: 'PLAYBACKRATE_CHANGE',
                        playbackRate: newPlaybackRate,
                        source: 'shortcut',
                    });
                },
            },
        ];
        var getShortcutKey = function (_a) {
            var _b = _a.keyCode, keyCode = _b === void 0 ? 0 : _b, _c = _a.ctrl, ctrl = _c === void 0 ? false : _c, _d = _a.shift, shift = _d === void 0 ? false : _d, _e = _a.alt, alt = _e === void 0 ? false : _e;
            return "".concat(keyCode, ":").concat(ctrl, ":").concat(shift, ":").concat(alt);
        };
        var defaultShortcuts = standardShortcuts.reduce(function (shortcuts, shortcut) {
            var _a;
            return Object.assign(shortcuts, (_a = {},
                _a[getShortcutKey(shortcut)] = shortcut,
                _a));
        }, {});
        var mergedShortcuts = (props.shortcuts || []).reduce(function (shortcuts, shortcut) {
            var _a;
            var keyCode = shortcut.keyCode, handle = shortcut.handle;
            if (keyCode && typeof handle === 'function') {
                return Object.assign(shortcuts, (_a = {},
                    _a[getShortcutKey(shortcut)] = shortcut,
                    _a));
            }
            return shortcuts;
        }, defaultShortcuts);
        var gradeShortcut = function (s) {
            var score = 0;
            var ps = ['ctrl', 'shift', 'alt'];
            ps.forEach(function (key) {
                if (s[key]) {
                    score++;
                }
            });
            return score;
        };
        return Object.keys(mergedShortcuts)
            .map(function (key) { return mergedShortcuts[key]; })
            .sort(function (a, b) { return gradeShortcut(b) - gradeShortcut(a); });
    }, [
        currentTime,
        duration,
        hasStarted,
        playbackRate,
        props.shortcuts,
        rootElem,
        togglePlay,
        videoService,
        volume,
        shortcutsEnabled,
        isFullscreen,
    ]);
    var handleKeyPress = React.useCallback(function (e) {
        var _a, _b;
        if (!isActive) {
            return;
        }
        if (document.activeElement &&
            (hasClass(document.activeElement, 'cueplayer-react-control') ||
                hasClass(document.activeElement, 'cueplayer-react-menu-button-active') ||
                hasClass(document.activeElement, 'cueplayer-react-big-play-button'))) {
            return;
        }
        var keyCode = e.keyCode || e.which;
        var ctrl = e.ctrlKey || e.metaKey;
        var shift = e.shiftKey;
        var alt = e.altKey;
        var shortcut = shortCutsRef.current.filter(function (s) {
            if (!s.keyCode || s.keyCode - keyCode !== 0) {
                return false;
            }
            return !((s.ctrl !== undefined && s.ctrl !== ctrl) ||
                (s.shift !== undefined && s.shift !== shift) ||
                (s.alt !== undefined && s.alt !== alt));
        })[0];
        // check if progress bar slider is focused
        var activeElement = document.activeElement;
        var seekBarElement = rootElem === null || rootElem === void 0 ? void 0 : rootElem.querySelector('[data-reach-slider-handle]');
        var isSeekBarFocused = activeElement === null || activeElement === void 0 ? void 0 : activeElement.isEqualNode(seekBarElement || null);
        // only enable shortcuts if video element, document body, or progress bar is focused
        if (shortcut &&
            shortcutsEnabled &&
            (((_a = document.activeElement) === null || _a === void 0 ? void 0 : _a.nodeName) === 'BODY' ||
                ((_b = document.activeElement) === null || _b === void 0 ? void 0 : _b.nodeName) === 'VIDEO' ||
                isSeekBarFocused)) {
            shortcut.handle();
            e.preventDefault();
        }
    }, [isActive]);
    // only if player is active and player is ready
    var canBeClicked = React.useCallback(function (e) {
        var target = e.target;
        return !(!isActive || target.nodeName !== 'VIDEO' || readyState < 3);
    }, [isActive, readyState]);
    var handleClick = React.useCallback(function (e) {
        if (!canBeClicked(e) || !clickable) {
            return;
        }
        togglePlay();
        e.preventDefault();
    }, [canBeClicked, clickable, togglePlay]);
    var handleDoubleClick = React.useCallback(function (e) {
        if (!canBeClicked(e) || !dblclickable) {
            return;
        }
        videoService.send({
            type: 'TOGGLE_FULLSCREEN',
            element: rootElem,
        });
        e.preventDefault();
    }, [canBeClicked, dblclickable]);
    React.useEffect(function () {
        shortCutsRef.current = mergeShortcuts();
        if (!enableGlobalShortcuts) {
            rootElem === null || rootElem === void 0 ? void 0 : rootElem.addEventListener('keydown', handleKeyPress);
            rootElem === null || rootElem === void 0 ? void 0 : rootElem.addEventListener('click', handleClick);
            rootElem === null || rootElem === void 0 ? void 0 : rootElem.addEventListener('dblclick', handleDoubleClick);
            return function () {
                rootElem === null || rootElem === void 0 ? void 0 : rootElem.removeEventListener('keydown', handleKeyPress);
                rootElem === null || rootElem === void 0 ? void 0 : rootElem.removeEventListener('click', handleClick);
                rootElem === null || rootElem === void 0 ? void 0 : rootElem.removeEventListener('dblclick', handleDoubleClick);
            };
        }
        else {
            document.addEventListener('keydown', handleKeyPress);
            document.addEventListener('click', handleClick);
            document.addEventListener('dblclick', handleDoubleClick);
            return function () {
                document.removeEventListener('keydown', handleKeyPress);
                document.removeEventListener('click', handleClick);
                document.removeEventListener('dblclick', handleDoubleClick);
            };
        }
    }, [
        handleClick,
        handleDoubleClick,
        handleKeyPress,
        mergeShortcuts,
        rootElem,
        isFullscreen,
        enableGlobalShortcuts,
    ]);
    return null;
};
exports.Shortcut = Shortcut;
// check if an element has a class name
function hasClass(elm, cls) {
    var classes = elm.className.split(' ');
    for (var i = 0; i < classes.length; i++) {
        if (classes[i].toLowerCase() === cls.toLowerCase()) {
            return true;
        }
    }
    return false;
}
exports.hasClass = hasClass;
